var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdeaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 2.5c3.781 0 6.823 2.997 6.823 6.775 0 1.506-.384 2.489-1.342 3.977l-.541.829c-.404.634-.597 1.02-.731 1.482.098.198.153.42.153.655v1.393c0 .696-.48 1.28-1.128 1.438l-.285 1.29a1.48 1.48 0 0 1-1.445 1.161h-3.01a1.48 1.48 0 0 1-1.445-1.163l-.284-1.289a1.48 1.48 0 0 1-1.126-1.437v-1.393c0-.234.055-.456.151-.653l.02.061c-.137-.495-.33-.888-.76-1.561l-.345-.528C5.604 11.885 5.17 10.875 5.17 9.275c0-3.778 3.042-6.775 6.823-6.775z",
  fill: "#0481A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9E9",
  d: "M13.577 20.12h-3.17l-.35-1.597h3.872zm-4.565-2.409h5.963v-1.593H9.012z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 3.88c-3.006 0-5.443 2.367-5.443 5.395 0 2.631 1.961 3.728 2.583 5.985h5.72c.622-2.257 2.583-3.354 2.583-5.985 0-3.028-2.437-5.395-5.443-5.395z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 4.63C9.381 4.63 7.3 6.68 7.3 9.275c0 1.074.293 1.755 1.174 3.086l.086.13c.565.853.887 1.402 1.114 2.004l.004.014h4.629l.006-.014c.204-.542.485-1.04.95-1.757l.163-.247.019-.028.067-.102c.881-1.331 1.174-2.012 1.174-3.086 0-2.595-2.081-4.645-4.693-4.645z",
  fill: "#FDFFAB",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 5.88c-1.925 0-3.443 1.495-3.443 3.395 0 .765.21 1.253.966 2.396l.086.13c.371.56.65 1.007.87 1.428l.016.03h3.009l.016-.03c.184-.35.409-.72.693-1.157l.178-.271.086-.13c.756-1.143.966-1.63.966-2.396 0-1.9-1.517-3.395-3.443-3.395z",
  fill: "#FF0",
  fillRule: "nonzero"
}))));
export default SvgIdeaIcon;